import { Button } from 'antd';
import { useTranslation } from 'react-i18next';

const ViewportDeleteForm = ({ onClose, onSubmit, isLoading }) => {
  const { t } = useTranslation('Vindoc');

  return (
    <div className="flex flex-col gap-4">
      <p className="text-xl">{t('Are you sure to delete dicom study?')}</p>

      <div className="self-end">
        <Button
          data-cy="cancel-btn"
          onClick={onClose}
          className="px-2"
          disabled={isLoading}
        >
          {t('Cancel')}
        </Button>
        <Button
          className="ml-2"
          onClick={onSubmit}
          type="primary"
          data-cy="download-btn"
          loading={isLoading}
        >
          {t('Delete')}
        </Button>
      </div>
    </div>
  );
};

export default ViewportDeleteForm;
